import {
  Box,
  Button,
  Center,
  Flex,
  Loader,
  Modal,
  Paper,
  Table,
  Text,
  Title,
  createStyles,
} from "@mantine/core";
import { formatDateTime } from "@medplum/core";
import { StatusBadge, useMedplum } from "@medplum/react";
import { IconDownload, IconViewportWide, IconEye } from "@tabler/icons-react";
import { MouseEvent, Suspense, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  athenaHandler,
  filterByValueString,
  filterIdentifier,
  formatXml,
  getAccessToken,
  getTokenResponse,
  includesAthenaHealth,
} from "../../../utils";
import { showNotification } from "@mantine/notifications";
import { useSelector } from "react-redux";
import { AppState } from "../../../store/types/appState";
import axios from "axios";
import { useDispatch } from "react-redux";
import Highlight from "react-highlight";
import "highlight.js/styles/github.css";
import { documentRefrenceForPatient } from "../../ClinicalNotes/clinicalNotesService";
import { ClinicaTable } from "../../ClinicalNotes/ClinicalNotestable";

const useStyles = createStyles((theme) => ({
  table: {
    marginTop: "30px",
  },
  thead: {
    backgroundColor: "#BEDEF8",
    borderRadius: 4,
  },
  downloadLoader: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(0.5px)",
    zIndex: 9999,
  },
  scrollBar: {
    height: "76vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "10px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "2px",
      "&:hover": {
        background: "#555",
      },
    },
  },
  medicalDocPaper: {
    marginTop: "20px",
    borderRadius: "8px",
    marginLeft: "0px",
    marginRight: "0px",
    padding: "20px",
    background: "'#FFF",
    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
  },
}));

interface ReportProps {
  setIsMedicalDocumentModalOpen?: ((val: boolean) => void) | undefined;
  patient: any;
  refreshFlag: boolean;
}

interface IAccumulator {
  refreshToken?: string;
  integrationType?: string;
  name?: string;
}

export const DocReports = ({
  setIsMedicalDocumentModalOpen,
  patient,
  refreshFlag,
}: ReportProps) => {
  const { patientId } = useParams();
  const dispatch = useDispatch();
  const navigate =useNavigate()
  const { classes } = useStyles();
  const medplum = useMedplum();
  const [reports, setReports] = useState<any>([]);
  const [refrshDoc, setrefreshDoc] = useState<boolean>(false);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [isDownloading, setisDownloading] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pdfurl, setPdfUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [xmlContent, setXmlContent] = useState("");
  const [rtfToHtmlContent, setRfToHtmlContent] = useState("");
  const [data, setdata] = useState<any>("");
  const [isEpic, setIsEpic] = useState<boolean>(false);

  const logginedUser = useSelector((state: AppState) => state) as any;

  const tableHeaders = [
    "Report Name",
    "Category",
    "Description",
    "Date Issued On",
    "Status",
    "Download",
  ];

  const docmentRefForpatient = (Id: string, pageNumber: any) => {
    try {
      setIsFetching(true);
      documentRefrenceForPatient(Id, medplum, pageNumber)
        .then((docRefrenceData: any) => {
          const totalpages = Math.ceil(
            (docRefrenceData.bundle.total as any) / 20
          );

          // setTotal(totalpages);
          setReports(docRefrenceData);

          setIsFetching(false);
        })
        .catch((error: any) => {
          console.error("Error fetching patient list:", error);
          setIsFetching(false);
        });
    } catch (error) {
      setIsFetching(false);
      console.error("Error fetching patient list:", error);
      showNotification({
        color: "red",
        message: "Failed",
        autoClose: true,
      });
    }
  };
  const filteredData = filterByValueString(
    (logginedUser?.app?.profile?.extension as any) || [],
    "athenahealth"
  );

  useEffect(() => {
    {
      isEpic ? docmentRefForpatient(patientId as any, 1) : getDocReference();
    }
  }, [patientId, refreshFlag]);

  const getDocReference = async () => {
    const isAthenaPatient = includesAthenaHealth(patient?.identifier);

    const activeLogin = getAccessToken();

    const athenaPatientId =
      patient?.identifier &&
      filterIdentifier(patient?.identifier, "athena_patient_id");

    if (
      patient?.identifier?.find(
        (id:any) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
      )
    ) {
      setIsEpic(true);
      return;
    } else if (!isAthenaPatient) {
      showNotification({
        color: "red",
        message: "Please select an Athena Health Patient!",
        autoClose: true,
      });
      setIsFetching(false);
      return;
    }

    const filteredData = filterByValueString(
      (logginedUser?.app?.profile?.extension as any) || [],
      "athenahealth"
    );

    if (!filteredData?.length) {
      showNotification({
        color: "red",
        message: "Please connect with Athena Client first",
        autoClose: true,
      });
      setIsFetching(false);

      return;
    }

    try {
      const clientId =
        filteredData[filteredData?.length - 1]?.url?.split("/")?.[1];
      const result = filteredData[filteredData?.length - 1]?.extension?.reduce(
        (acc: IAccumulator, { url, valueString }) => {
          if (url === "refresh_token") {
            acc.refreshToken = valueString;
          } else if (url === "integrationType") {
            acc.integrationType = valueString;
          } else if (url === "display") {
            acc.name = valueString;
          }
          return acc;
        },
        {}
      );

      const metaData = {
        dispatch,
        clientId: clientId,
        integrationType: result.integrationType,
        refreshToken: result.refreshToken,
        activeLogin,
        name: result.name
      }

      const getDocsPayload = {
        eventType: "fetchDocs",
        patientId: athenaPatientId?.[0]?.value,
        accessToken:
          filteredData[filteredData?.length - 1]?.extension?.[0]?.valueString ||
          "",
      };
      const res = await athenaHandler(medplum, getDocsPayload, metaData);
      if (res.statusCode === 200) {
        setReports(res?.body?.entry);
      }
    } catch (error) {
      console.error(error);
      showNotification({
        color: "red",
        message: `${error}`,
        autoClose: true,
      });
    }
    setIsFetching(false);
  };

  function parseRTF(rtf: string): string {
    return rtf
      .replace(/\\par[d]?/g, "<br>")
      .replace(/{\\b\s([^}]*)}/g, "<b>$1</b>")
      .replace(/\\[a-z]+\d*/g, "")
      .replace(/[\{\}\\]/g, "");
  }
  const getCategory = (category: any) => {
    let text = "";
    if (category?.length > 0) {
      for (let i = 0; i < category?.length; i++) {
        if (category[i].coding) {
          for (let j = 0; j < category[i].coding?.length; j++) {
            text = category[i].coding[j].display;
          }
        }
      }
      return text;
    }
  };
  function handleXmlFile(
    fileString: string,
    fileName: string
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const blob = new Blob([fileString], {
        type: "application/xml;charset=utf-8",
      });
      fileName = `${fileName}.xml`;
      const fileType = "xml";
      const reader = new FileReader();

      reader.onloadend = () => {
        if (reader.result) {
          const formattedXml = reader.result.toString();
          const formattedXmlString = formatXml(formattedXml);

          resolve(formattedXmlString);
        } else {
          reject(new Error("Failed to read the file"));
        }
      };

      reader.onerror = () => {
        reject(new Error("FileReader error"));
      };

      reader.readAsText(blob);
    });
  }

  async function handleUploadButtonClick(e: MouseEvent<HTMLButtonElement>) {
    if (setIsMedicalDocumentModalOpen) setIsMedicalDocumentModalOpen(true);
  }

  const handleDownloadClick = async (binary: string, view?: boolean) => {
    try {
      setisDownloading(true);

      const downloadDocPayload = {
        eventType: "downloadDoc",
        docId: binary,
        accessToken:
          filteredData[filteredData?.length - 1]?.extension?.[0]?.valueString,
      };
      const res = await athenaHandler(medplum, downloadDocPayload);
      if (res?.statusCode === 500) {
        showNotification({
          color: "red",
          message: "Uknown file type ",
          autoClose: true,
        });
        setisDownloading(false);
        return;
      }
      if (view === true) {
        viewFile(
          res?.body,
          downloadDocPayload?.docId,
          downloadDocPayload?.accessToken
        );
      } else {
        downloadFile(
          res?.body,
          downloadDocPayload?.docId,
          downloadDocPayload?.accessToken
        );
      }
    } catch (error) {
      console.error(error);
      setIsFetching(false);
    }
  };

  async function viewFile(
    fileString: string,
    fileName: string,
    accessToken: string
  ) {
    if (!fileString) {
      console.error("XML string is empty.");
      setisDownloading(false);
      showNotification({
        color: "red",
        message: "Failed",
        autoClose: true,
      });
      return;
    }

    let blob: Blob | null = null;
    let fileType = "";

    if (fileString.startsWith("{\\rtf1\\")) {
      blob = new Blob([fileString], { type: "application/rtf;charset=utf-8" });
      const converted = parseRTF(fileString);

      setRfToHtmlContent(converted);
      fileName = `${fileName}.rtf`;
      fileType = "rtf";

      setFileName(fileName);
      setIsModalOpen(true);
      setisDownloading(false);
      setIsFetching(false);
      showNotification({
        color: "green",
        message: "File opened successfully",
        autoClose: true,
      });
      return;
    } else if (fileString.startsWith("%PDF")) {
      const response = await axios.get(
        `https://ap23sandbox.fhirapi.athenahealth.com/demoAPIServer/fhir/r4/${fileName}`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data) {
        blob = new Blob([response.data], { type: "application/pdf" });
        fileName = `${fileName}.pdf`;
        fileType = "pdf";

        setFileName(fileName);
      }
    } else if (fileString.startsWith("data:image")) {
      const base64Data = fileString.split(",")[1];
      blob = new Blob(
        [Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0))],
        { type: "image/png" }
      );
      fileName = `${fileName}.png`;
      fileType = "image";

      const url = window.URL.createObjectURL(blob);
      setPdfUrl(url);

      setFileName(fileName);
      setIsModalOpen(true);
      setisDownloading(false);
      setIsFetching(false);
      showNotification({
        color: "green",
        message: "File opened successfully",
        autoClose: true,
      });
      return;
    } else if (fileString.startsWith("PK")) {
      // assuming the docx starts with PK
      const response = await axios.get(
        `https://ap23sandbox.fhirapi.athenahealth.com/demoAPIServer/fhir/r4/${fileName}`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data) {
        blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        fileName = `${fileName}.docx`;
        fileType = "docx";

        setFileName(fileName);
      }
    } else {
      handleXmlFile(fileString, fileName)
        .then((formattedXmlString) => {
          setXmlContent(formattedXmlString);
          setIsModalOpen(true);

          setFileName(fileName);
          setisDownloading(false);

          setIsFetching(false);
          showNotification({
            color: "green",
            message: "File opened successfully",
            autoClose: true,
          });
        })
        .catch((error) => {
          console.error(error);
        });

      // reader.readAsText(blob);
      return;
    }

    if (blob) {
      const url = window.URL.createObjectURL(blob);
      const iframe = document.createElement("iframe");
      iframe.src = url;
      setPdfUrl(url);

      iframe.width = "100%";
      iframe.height = "600px";

      const container = document.getElementById("file-viewer");
      if (container) {
        container.innerHTML = "";
        container.appendChild(iframe);
      } else {
        console.error("Container element with id 'file-viewer' not found.");
      }

      setisDownloading(false);
      setIsFetching(false);
      setIsModalOpen(true);
      showNotification({
        color: "green",
        message: "File opened successfully",
        autoClose: true,
      });
    } else {
      console.error("Failed to create Blob object.");
      setisDownloading(false);
      showNotification({
        color: "red",
        message: "Failed to open file",
        autoClose: true,
      });
    }
  }

  async function downloadFile(
    fileString: string,
    fileName: string,
    accessToken: string
  ) {
    if (!fileString) {
      console.error("XML string is empty.");
      setisDownloading(false);
      return;
    }

    let blob;

    if (fileString.startsWith("{\\rtf1\\")) {
      blob = new Blob([fileString], { type: "application/rtf;charset=utf-8" });
      fileName = `${fileName}.rtf`;
    } else if (fileString.startsWith("%PDF")) {
      const response = await axios.get(
        `https://ap23sandbox.fhirapi.athenahealth.com/demoAPIServer/fhir/r4/${fileName}`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data) {
        blob = new Blob([response.data], { type: "application/octet-stream" });
        fileName = `${fileName}.pdf`;
      }
    } else {
      blob = new Blob([fileString], { type: "application/xml;charset=utf-8" });
      fileName = `${fileName}.xml`;
    }

    if (blob) {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setisDownloading(false);
      setIsFetching(false);
      showNotification({
        color: "green",
        message: "Download Successful",
        autoClose: true,
      });
    } else {
      console.error("Failed to create Blob object.");
      setisDownloading(false);
      showNotification({
        color: "red",
        message: "Download Failed",
        autoClose: true,
      });
    }
  }

  return (
    <>
      {isEpic ? (
        <>
          <Paper className={classes.medicalDocPaper} withBorder>
            <Flex justify={"space-between"}>
              <Title>Clinical Documents</Title>
              <Button onClick={()=>{navigate(`/admin/clinical-notes/new-clinical-notes/${patientId}`);}}>New Document</Button>
            </Flex>
            <ClinicaTable patientID={patientId} />
          </Paper>
        </>
      ) : (
        <>
          {" "}
          <Box>
            <Modal
              // title={fileName}
              opened={isModalOpen}
              onClose={() => {
                setIsModalOpen(false);
                setdata("");
                setXmlContent("");
                setRfToHtmlContent("");
                setPdfUrl("");
              }}
              size="xl"
              withCloseButton={true}
              closeOnEscape={true}
              closeOnClickOutside={true}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingBottom: "12px",
                }}
              >
                <Flex align="center">{fileName}</Flex>{" "}
                <Button onClick={() => handleDownloadClick(data, false)}>
                  <IconDownload />
                  <Text ml={8}>Download</Text>
                </Button>
              </Box>

              <div id="file-viewer" style={{ width: "100%", height: "100%" }}>
                {pdfurl && (
                  <iframe
                    title="PDF Viewer"
                    src={pdfurl}
                    style={{ width: "100%", height: "76vh", border: "none" }}
                  />
                )}

                {xmlContent && (
                  <Suspense fallback={<div>Loading...</div>}>
                    <Box className={classes.scrollBar}>
                      <Highlight className="xml">{xmlContent}</Highlight>
                    </Box>
                  </Suspense>
                )}
                {rtfToHtmlContent && (
                  <Box
                    className={classes.scrollBar}
                    dangerouslySetInnerHTML={{ __html: rtfToHtmlContent }}
                  />
                )}
              </div>
            </Modal>
          </Box>
          <Paper className={classes.medicalDocPaper} withBorder>
            <Flex justify={"space-between"}>
              <Title>Clinical Documents</Title>
              <Button onClick={handleUploadButtonClick}>New Document</Button>
            </Flex>
            {isFetching ? (
              <Center>
                <Loader />
              </Center>
            ) : (
              <Table className={classes.table}>
                <thead className={classes.thead}>
                  <tr>
                    {tableHeaders?.map((val) => {
                      return <th key={val}>{val}</th>;
                    })}
                  </tr>
                </thead>
                {
                  <tbody>
                    {reports?.map((data: any) => (
                      <tr key={data?.resource?.id}>
                        <td>{data?.resource?.type?.coding[0]?.display}</td>
                        <td>{getCategory(data?.resource?.category)}</td>
                        <td>
                          {data?.resource?.description?.length > 0
                            ? data?.resource?.description
                            : ""}
                        </td>
                        <td>{formatDateTime(data?.resource?.date)}</td>
                        <td>
                          <StatusBadge
                            status={data?.resource?.docStatus as string}
                          />
                        </td>
                        <td
                          onClick={() => {
                            setdata(
                              data?.resource?.content[0]?.attachment?.url
                            );
                          }}
                        >
                          <IconDownload
                            color="#228be6"
                            onClick={() =>
                              handleDownloadClick(
                                data?.resource?.content[0]?.attachment?.url,
                                true
                              )
                            }
                            style={{
                              marginRight: "10px",
                              marginLeft: "8px",
                              cursor: "pointer",
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                }
              </Table>
            )}
            {reports?.length === 0 && !isFetching && (
              <Center style={{ width: "100%", height: "200px" }}>
                <Text size="xl" color="dimmed">
                  No results
                </Text>
              </Center>
            )}
            {isDownloading && (
              <Center className={classes.downloadLoader}>
                <Loader />
              </Center>
            )}
          </Paper>
        </>
      )}
    </>
  );
};
